import { escapeHtml } from 'features/shared/utility/escapeHtml';
import htmlForPrinting from '../../../utils/htmlForPrinting';

export const buildSOPDetailPrintHTML = (viewTarget, detailFields, title = '') => {
  const tableHtml = `
      <h4>${escapeHtml(title)}</h4>
      <table>
        <tbody>
          ${detailFields
            .map(({ field, label, valueGetter, render }) => {
              const value = valueGetter ? valueGetter(viewTarget) : viewTarget[field];
              const display = render ? render(value) : value ?? '';
              return `<tr><th>${escapeHtml(label)}</th><td>${escapeHtml(
                String(display ?? '')
              )}</td></tr>`;
            })
            .join('')}
        </tbody>
      </table>
    `;

  return htmlForPrinting(tableHtml, title);
};